export default __webpack_public_path__ + "static/media/Nitroxgallery_8.79a0bf06.JPG";